import { faHelmetSafety, faShirt } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import Boolean from '../../collection/icons/Boolean';

/**
 * FontAwesome icon that represents whether a clothing piece is a safety element.
 * Other props: See Boolean.
 */
export default function EpiBoolean(props) {
    const { ...otherProps } = props;
    return <Boolean {...otherProps} />;
}

EpiBoolean.defaultProps = {
    trueTitle: "EPI",
    falseTitle: "Ropa",
    trueIcon: faHelmetSafety,
    falseIcon: faShirt,
    trueColor: "warning",
    falseColor: "info"
}
